import React from 'react';
import './ComingSoon.css';

const ComingSoon = () => {
  return (
    <div className="coming-soon-page">
      <div className="coming-soon__illustration">
        <svg
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
          className="coming-soon__svg"
          aria-hidden
        >
          <defs>
            <linearGradient id="rocketGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#8b5cf6" />
            </linearGradient>
            <linearGradient id="flameGrad" x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" stopColor="#f59e0b" />
              <stop offset="50%" stopColor="#ef4444" />
              <stop offset="100%" stopColor="#fbbf24" />
            </linearGradient>
          </defs>
          {/* Rocket body */}
          <ellipse cx="100" cy="95" rx="28" ry="55" fill="url(#rocketGrad)" className="rocket-body" />
          <ellipse cx="100" cy="58" rx="18" ry="22" fill="#e0e7ff" opacity="0.9" />
          {/* Window */}
          <circle cx="100" cy="72" r="10" fill="#c7d2fe" className="rocket-window" />
          {/* Fins */}
          <path d="M 72 120 L 72 165 L 85 145 Z" fill="url(#rocketGrad)" opacity="0.8" className="rocket-fin" />
          <path d="M 128 120 L 128 165 L 115 145 Z" fill="url(#rocketGrad)" opacity="0.8" className="rocket-fin rocket-fin-r" />
          {/* Flame */}
          <g className="flame-group">
            <path d="M 85 148 Q 100 185 115 148 Q 100 165 85 148" fill="url(#flameGrad)" className="flame" />
            <path d="M 88 152 Q 100 180 112 152 Q 100 168 88 152" fill="#fcd34d" opacity="0.8" className="flame flame-inner" />
          </g>
          {/* Stars / sparkles */}
          <g className="sparkles">
            <circle cx="40" cy="45" r="3" fill="#fbbf24" className="sparkle" />
            <circle cx="165" cy="60" r="2.5" fill="#a78bfa" className="sparkle sparkle-2" />
            <circle cx="55" cy="130" r="2" fill="#f472b6" className="sparkle sparkle-3" />
            <circle cx="150" cy="110" r="2.5" fill="#34d399" className="sparkle sparkle-4" />
          </g>
        </svg>
      </div>
      <h1 className="coming-soon__title">Something Exciting is Coming Soon!</h1>
      <p className="coming-soon__text">
        Our team is crafting a fantastic experience for you. Stay tuned and get ready to be amazed!
      </p>
    </div>
  );
};

export default ComingSoon;
